__turbopack_context__.v({
  "correct-highlight": "vpdqnq_correct-highlight",
  "incorrect-highlight": "vpdqnq_incorrect-highlight",
  "missed-highlight": "vpdqnq_missed-highlight",
  "user-highlight": "vpdqnq_user-highlight",
});
